import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative flex items-center justify-center overflow-hidden" style={{ minHeight: "72vh" }}>
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ae8fa22c92187e58a2b5fd5994425521.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/55"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto pt-24 pb-16">
        {/* 로고 */}
        <div className="flex items-center justify-center gap-3 mb-5">
          <img
            src="https://readdy.ai/api/search-image?query=minimalist%20elegant%20leaf%20sprout%20logo%20design%20natural%20green%20color%20simple%20clean%20lines%20sustainable%20growth%20symbol%20modern%20organic%20brand%20identity%20vector%20style%20white%20background&width=120&height=120&seq=daygreen-logo&orientation=squarish"
            alt="Daygreen 로고"
            className="h-12 w-12 object-contain rounded-full bg-white/10 p-1"
          />
          <span className="text-2xl font-bold text-white tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Daygreen
          </span>
        </div>

        {/* 사회적기업 뱃지 */}
        <div className="flex items-center justify-center gap-3 mb-7 flex-wrap">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-emerald-600/80 text-white text-xs font-semibold tracking-wide border border-emerald-400/50 backdrop-blur-sm whitespace-nowrap">
            <i className="ri-award-line text-sm"></i>
            인증 사회적기업
          </span>
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-white/10 text-white/90 text-xs font-medium tracking-wide border border-white/25 backdrop-blur-sm whitespace-nowrap">
            <i className="ri-recycle-line text-sm"></i>
            지속가능한 패션
          </span>
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-white/10 text-white/90 text-xs font-medium tracking-wide border border-white/25 backdrop-blur-sm whitespace-nowrap">
            <i className="ri-community-line text-sm"></i>
            기술 자립 공동체
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-white mb-5 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          기술로 자립하고,
          <br />
          <span className="text-emerald-300">존중으로 지속된다</span>
        </h1>
        <p className="text-base md:text-lg text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
          재봉틀 한 대에서 시작된 기술 공동체가
          <br />
          지속가능한 산업을 만들어갑니다
        </p>

        {/* 사회적 가치 지표 */}
        <div className="flex items-center justify-center gap-8 mb-10 flex-wrap">
          <div className="text-center">
            <div className="text-2xl font-bold text-emerald-300" style={{ fontFamily: "'Cormorant Garamond', serif" }}>120+</div>
            <div className="text-white/70 text-xs mt-0.5" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>자립 지원 인원</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-emerald-300" style={{ fontFamily: "'Cormorant Garamond', serif" }}>8년</div>
            <div className="text-white/70 text-xs mt-0.5" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>사회적기업 운영</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-emerald-300" style={{ fontFamily: "'Cormorant Garamond', serif" }}>3개</div>
            <div className="text-white/70 text-xs mt-0.5" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>자체 브랜드</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl font-bold text-emerald-300" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Zero</div>
            <div className="text-white/70 text-xs mt-0.5" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>폐기물 목표</div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/brand" className="px-9 py-3.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg">
            브랜드 보기
          </Link>
          <Link to="/about" className="px-9 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-lg hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer">
            공동체 이야기
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
